<template>
  <div>
    <header>
      <!-- Header content goes here -->
    </header>
    <main>
      <router-view></router-view>
    </main>
    <footer>
      <!-- Footer content goes here -->
    </footer>
  </div>
</template>
